import { render, staticRenderFns } from "./orderDesc.vue?vue&type=template&id=5a7df1ce"
import script from "./orderDesc.vue?vue&type=script&lang=ts"
export * from "./orderDesc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports